import {Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    updateComparsionChartData,
    updateDisqualificationReasonDialogData
} from "../../../../store/slice/bidComparsionChart";
import {usePostDisqualifyMutation} from "../../../../store/api/bidComparsion";

const DisqualificationReasonDialog = () => {
    const dispatch = useDispatch()
    const [comment, setComment] = useState('')
    const disqualificationReasonDialogData = useSelector((state) => state.bidComparsionSlice.disqualificationReasonDialogData)
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const [postDisqualify] = usePostDisqualifyMutation()
    const save = () => {
        const index = chartData?.bids?.findIndex(item => item?.bidMainId == disqualificationReasonDialogData?.bidMainId)
        let newChartData = {...chartData}
        let newBids = [...chartData?.bids]
        let bidItem = {...newBids[index]}
        bidItem.discualified = true
        bidItem.discualificationReason = comment
        postDisqualify({
            bidMainId: bidItem?.bidMainId,
            discualified: bidItem?.discualified ? 1 : 0,
            discualificationReason: bidItem?.discualificationReason
        })
        newBids[index] = bidItem
        newChartData.bids = newBids
        dispatch(updateComparsionChartData(newChartData))
        dispatch(updateDisqualificationReasonDialogData(null))
        setComment('')
    }

    const close = () => {
        dispatch(updateDisqualificationReasonDialogData(null))
    }

    useEffect(() => {
        if (disqualificationReasonDialogData) {
            setComment(disqualificationReasonDialogData?.discualificationReason)
        }
    }, [disqualificationReasonDialogData])

    return (
        <>
            <DialogTitle>
                Disqualification Reason for {disqualificationReasonDialogData?.bidNo}
            </DialogTitle>
            <DialogContent>
                <Box sx={{mt: 2}}>
                    <FormControl fullWidth>
                        <TextField label="Disqualification Reason" multiline value={comment}
                                   onChange={e => setComment(e.target.value)}
                                   rows={4}/>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='contained'
                        onClick={save}
                        disabled={!comment}>Yes</Button>
                <Button variant="outlined" onClick={close} sx={{color: 'gray', borderColor: '#D3D3D3'}}>
                    Cancel
                </Button>
            </DialogActions>
        </>
    )
}

export default DisqualificationReasonDialog